import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const ColumnField = iotsUtils.fromList(
	constants.user.preferences.uiSettingsTemplate.columnFields
);
